import * as yup from 'yup'

export class SettingsReadyForOutboundDateInformationDto {
  readyForOutboundNumberOfDaysBeforeVehicleRelease?: number = undefined
}

export const readyForOutboundDateInformationValidationSchema = yup.object<SettingsReadyForOutboundDateInformationDto>({
  readyForOutboundNumberOfDaysBeforeVehicleRelease: yup
    .number()
    .min(0, 'Ready For Outbound Date Information cannot be less then 0 days.')
    .max(999_999_999_999_999, 'Ready For Outbound Date Information cannot be more than 999,999,999,999,999 days.')
    .required('Ready For Outbound Date Information is required.')
})
